<template>
    <app-layout>
        <base-header bg-from="from-emerald-500" bg-to="to-lime-400" :shadow="false">
            <div class="pt-16 pb-24">
                <h2 class="text-2xl leading-9 font-medium text-white opacity-60">
                    {{ $t('dashboard.welcome_back') }}{{ auth.user ? ',' : '' }}
                </h2>
                <h1 class="text-3xl leading-9 font-bold text-white" v-if="auth.user">
                    {{ auth.user.name }}!
                </h1>
            </div>
        </base-header>

        <base-content overlap>
            <div class="mt-6">
                <div class="flex justify-between items-center mb-5">
                    <element-title>
                        {{ $moment().format('MMMM YYYY') }}
                    </element-title>
                </div>

                <profit-and-loss-index-table :busy="isLoadingStores" :stores="stores" card/>
            </div>

            <admin v-if="auth.user.isAdmin"/>
        </base-content>
    </app-layout>
</template>

<script>
import Admin from '@/Pages/Dashboard/Components/Admin';
import ProfitAndLossIndexTable from '@/Pages/Dashboard/Components/ProfitAndLossIndexTable';

export default {
    components: {Admin, ProfitAndLossIndexTable},
    props: ['user'],

    data() {
        return {
            isLoadingStores: true,
            stores: [],
        };
    },

    metaInfo() {
        return {
            title: 'Dashboard',
        };
    },

    computed: {
        auth() {
            return auth;
        },
    },

    mounted() {
        axios.get(route('api.stores.profit-and-loss.index')).then((response) => {
            this.isLoadingStores = false;
            this.stores = response.data;
        });
    },
};
</script>
